import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import { UiModule } from '@collab/comp-library';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormInlineErrorComponent } from './components/form-inline-error/form-inline-error.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { StaticTableComponent } from './components/static-table/static-table.component';
import { ActionsButtonRendererComponent } from './components/actions-button-renderer/actions-button-renderer.component';
import { CardComponent } from './components/card/card.component';
import { IndentPipe } from './pipes/indent.pipe';
import { NonEditableTextAreaDirective } from './directives/non-editable-textarea.directive';
import { DragDropDirective } from './directives/drag-drop.directive';
import { BoldPipe } from './pipes/bold.pipe';
import { ToastMessagesComponent } from './components/toast-messages/toast-messages.component';
import { AlertWrapperComponent } from './components/alert-wrapper/alert-wrapper.component';
import { ConnectorActionButtonRendererComponent } from './components/connector-action-button-renderer.component';
import { HealthMonitoringActionsButtonRendererComponent } from './components/health-monitoring-actions-button-renderer.component';
import { DynamicTooltipDirective } from './directives/dynamic-tooltip.directive';
import { WarningAlertWrapperComponent } from './components/warning-alert-wrapper/warning-alert-wrapper.component';
import { TabNavigatorsComponent } from './components/tab-navigator/tab-navigator.component';
import { TicketCustomPopupComponent } from './components/ticket-custom-popup/ticket-custom-popup-renderer.component';
import { DebtCustomPopupComponent } from './components/debt-custom-popup/debt-custom-popup-renderer.component';
import { VolumeForeactingCustomPopupComponent } from './components/volume-forecasting-custom-popup/volume-forecasting-custom-popup-renderer.component';
import { CapitalizeWordsPipe } from './pipes/capitalizewords.pipe';
import { HealthServiceActionButtonRendererComponent } from './components/health-service-action-button-renderer.component';
import { ChartExportService } from './services/chart-export.service';
import { FileInputComponent } from './components/file-input/file-input.component';
import { MenuItemComponent } from './components/drop-down/menu-item/menu-item.component';
import { SelectComponent } from './components/drop-down/select/select.component';
import { BadgeRendererComponent } from './components/badge-renderer/badge-renderer.component';
import { ProgressCircleComponent } from './components/progressbar/progress-circle/progress-circle.component';
import { ChartLoaderComponent } from './components/chart-loader/chart-loader.component';
import { CustomDateRangePickerComponent } from './components/custom-date-range-picker/custom-date-range-picker.component';

@NgModule({
    declarations: [
        FormInlineErrorComponent,
        FooterComponent,
        LoaderComponent,
        FileUploadComponent,
        StaticTableComponent,
        ActionsButtonRendererComponent,
        CardComponent,
        IndentPipe,
        NonEditableTextAreaDirective,
        DragDropDirective,
        BoldPipe,
        ToastMessagesComponent,
        AlertWrapperComponent,
        ConnectorActionButtonRendererComponent,
        HealthMonitoringActionsButtonRendererComponent,
        WarningAlertWrapperComponent,
        TabNavigatorsComponent,
        TicketCustomPopupComponent,
        DebtCustomPopupComponent,
        VolumeForeactingCustomPopupComponent,
        CapitalizeWordsPipe,
        HealthServiceActionButtonRendererComponent,
        FileInputComponent,
        DragDropDirective,
        MenuItemComponent,
        SelectComponent,
        BadgeRendererComponent,
        ProgressCircleComponent,
        ChartLoaderComponent,
        CustomDateRangePickerComponent

    ],
    imports: [
        CommonModule,
        SharedRoutingModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatNativeDateModule
    ],
    providers: [DecimalPipe, ChartExportService],
    exports: [
        CommonModule,
        UiModule,
        FormInlineErrorComponent,
        FooterComponent,
        LoaderComponent,
        HighchartsChartModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatNativeDateModule,
        FileUploadComponent,
        StaticTableComponent,
        ActionsButtonRendererComponent,
        CardComponent,
        IndentPipe,
        NonEditableTextAreaDirective,
        BoldPipe,
        ToastMessagesComponent,
        AlertWrapperComponent,
        ConnectorActionButtonRendererComponent,
        HealthMonitoringActionsButtonRendererComponent,
        WarningAlertWrapperComponent,
        TabNavigatorsComponent,
        TicketCustomPopupComponent,
        DebtCustomPopupComponent,
        VolumeForeactingCustomPopupComponent,
        CapitalizeWordsPipe,
        HealthServiceActionButtonRendererComponent,
        FileInputComponent,
        DragDropDirective,
        MenuItemComponent,
        SelectComponent,
        ProgressCircleComponent,
        ChartLoaderComponent,
        CustomDateRangePickerComponent

    ],
})
export class SharedModule { }
